import Email from './email.png';
import Szekhely from './szekhely.png';
import Telefon from './telefon.png';
import "./kapcsolat.css";


export function Kapcsolat(){


    return(
        <div className="kapcsolat-container">
            <div className="telefonszam-container">
                <img src={Telefon}></img>
                <h2>Telefonszám</h2>
                <h3>+36301827202</h3>
            </div>

            <div className="email-container">
                <img src={Email}></img>
                <h2>Email</h2>
                <h3>info@csaszartravel.hu</h3>
            </div>

            <div className="szekhely-container">
                <img src={Szekhely}></img>
                <h2>Székhely</h2>
                <h3>8960 Lenti, Kossuth út 1.</h3>
            </div>
        </div>
    )
}